<div class="grid">
    <div class="col-12">
        <form [formGroup]="vehicleForm">
            <p-card [header]="'ADD_VEHICLE' | translate">
                <p-messages [(value)]="messages" [closable]="true" />
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="vrn" class="text-sm text-500">{{
                            "VEHICLE_REGISTRATION_NUMBER" | translate
                        }}</label>
                        <input
                            type="text"
                            id="vrn"
                            [placeholder]="
                                'Vehicle Registration Number / Licence Plate Number'
                            "
                            pInputText
                            formControlName="registrationNumber"
                        />
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="selectedLanguage === 'en'"
                    >
                        <label htmlFor="make" class="text-sm text-500">{{
                            "VEHICLE_MAKE" | translate
                        }}</label>
                        <p-dropdown
                            id="make"
                            [options]="vehicleMetadata"
                            [filter]="true"
                            filterBy="name"
                            optionLabel="name"
                            placeholder="Select vehicle make"
                            (onChange)="onModelChange($event)"
                        ></p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="selectedLanguage === 'pt'"
                    >
                        <label htmlFor="make" class="text-sm text-500">{{
                            "VEHICLE_MAKE" | translate
                        }}</label>
                        <p-dropdown
                            id="make"
                            [options]="vehicleMetadata"
                            [filter]="true"
                            filterBy="name"
                            optionLabel="name"
                            placeholder="Selecione a marca do veículo"
                            (onChange)="onModelChange($event)"
                        ></p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="selectedLanguage === 'en'"
                    >
                        <label htmlFor="model" class="text-sm text-500">{{
                            "VEHICLE_MODEL" | translate
                        }}</label>
                        <p-dropdown
                            [filter]="true"
                            id="mode"
                            filterBy="name"
                            [options]="vehicleModels"
                            optionLabel="name"
                            placeholder="Select vehicle model"
                            formControlName="model"
                        ></p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="selectedLanguage === 'pt'"
                    >
                        <label htmlFor="model" class="text-sm text-500">{{
                            "VEHICLE_MODEL" | translate
                        }}</label>
                        <p-dropdown
                            [filter]="true"
                            id="mode"
                            filterBy="name"
                            [options]="vehicleModels"
                            optionLabel="name"
                            placeholder="Selecione o modelo do veículo"
                            formControlName="model"
                        ></p-dropdown>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label
                            htmlFor="yearOfManufacture"
                            class="text-sm text-500"
                            >{{ "YEAR_OF_MANUFACTURE" | translate }}</label
                        >
                        <p-calendar
                            [(ngModel)]="selectedYear"
                            view="year"
                            [placeholder]="'YEAR_OF_MANUFACTURE' | translate"
                            dateFormat="yy"
                            [yearNavigator]="true"
                            [yearRange]="yearRange"
                            formControlName="yearOfManufacture"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                        >
                        </p-calendar>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label
                            htmlFor="carryingCapacity"
                            class="text-sm text-500"
                            >{{ "CARRYING_CAPACITY" | translate }}</label
                        >
                        <input
                            type="number"
                            [min]="0"
                            id="carryingCapacity"
                            [placeholder]="'CARRYING_CAPACITY' | translate"
                            pInputText
                            formControlName="carryingCapacity"
                        />
                    </div>

                    <div class="field col-12 md:col-4">
                        <label
                            htmlFor="engineCapacity"
                            class="text-sm text-500"
                            >{{ "ENGINE_CAPACITY" | translate }}</label
                        >
                        <input
                            type="number"
                            [min]="0"
                            id="engineCapacity"
                            [placeholder]="'ENGINE_CAPACITY' | translate"
                            pInputText
                            formControlName="engineCapacity"
                        />
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="vehicleValue" class="text-sm text-500"
                            >{{ "VEHICLE_VALUE" | translate }} (in MZN)</label
                        >
                        <p-inputNumber
                            [min]="0"
                            placeholder="Vehicle Value e.g. MZN 120,000"
                            formControlName="vehicleValue"
                        >
                        </p-inputNumber>
                    </div>

                    <div
                        class="field col-12 md:col-4"
                        *ngIf="configOptions && selectedLanguage === 'en'"
                    >
                        <label htmlFor="vehicleType" class="text-sm text-500">{{
                            "VEHICLE_TYPE" | translate
                        }}</label>
                        <p-dropdown
                            id="vehicleType"
                            [options]="vehicleTypes"
                            optionLabel="name"
                            optionValue="value"
                            formControlName="vehicleType"
                            placeholder="Select Vehicle Type"
                        ></p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="configOptions && selectedLanguage === 'pt'"
                    >
                        <label htmlFor="vehicleType" class="text-sm text-500">{{
                            "VEHICLE_TYPE" | translate
                        }}</label>
                        <p-dropdown
                            id="vehicleType"
                            [options]="vehicleTypes"
                            optionLabel="name"
                            optionValue="value"
                            formControlName="vehicleType"
                            placeholder="Tipo de Viatura"
                        ></p-dropdown>
                    </div>

                    <div
                        class="field col-12 md:col-4"
                        *ngIf="configOptions && selectedLanguage === 'en'"
                    >
                        <label htmlFor="weight" class="text-sm text-500">{{
                            "WEIGHT_CATEGORY" | translate
                        }}</label>
                        <p-dropdown
                            id="weight"
                            *ngIf="configOptions"
                            [options]="weightCategories"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select vehicle weight category"
                            formControlName="weight"
                        ></p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="configOptions && selectedLanguage === 'pt'"
                    >
                        <label htmlFor="weight" class="text-sm text-500">{{
                            "WEIGHT_CATEGORY" | translate
                        }}</label>
                        <p-dropdown
                            id="weight"
                            *ngIf="configOptions"
                            [options]="weightCategories"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Categoria de Peso"
                            formControlName="weight"
                        ></p-dropdown>
                    </div>

                    <div class="field col-12 md:col-4" *ngIf="configOptions">
                        <label htmlFor="usage" class="text-sm text-500">{{
                            "VEHICLE_USAGE" | translate
                        }}</label>
                        <p-dropdown
                            id="usage"
                            *ngIf="configOptions && selectedLanguage === 'en'"
                            [options]="vehicleUsages"
                            optionLabel="name"
                            optionValue="value"
                            formControlName="vehicleUse"
                            placeholder="Select Vehicle's Usage"
                        ></p-dropdown>
                        <p-dropdown
                            id="usage"
                            *ngIf="configOptions && selectedLanguage === 'pt'"
                            [options]="vehicleUsages"
                            optionLabel="name"
                            optionValue="value"
                            formControlName="vehicleUse"
                            placeholder="Propósito de viatura "
                        ></p-dropdown>
                    </div>
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-arrow-left"
                            pRipple
                            (click)="goBackClicked()"
                            [label]="'Back' | translate"
                            severity="secondary"
                        />
                        <p-button
                            icon="pi pi-times-circle"
                            pRipple
                            
                            (click)="clearForm()"
                            [label]="'Clear' | translate"
                            severity="danger"
                        />

                        <button
                            icon="pi pi-check"
                            [label]="'Save' | translate"
                            [disabled]="vehicleForm.invalid"
                            severity="success"
                            pTooltip="Add vehicle to my profile"
                            pButton
                            pRipple
                            (click)="saveVehicle()"
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
